import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cross from "../../assets/images/icon/cross.svg";
import { faImages, faLock, faUpload } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { at, isEmpty } from "lodash";
import { toast } from "react-toastify";
import { uploadUserDocuments } from "helpers/backend_helper";
import { useEffect, useState } from "react";
import { bytesToMB } from "helpers/common";
import edit_icon from "../../assets/images/icon/edit.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { checkPermissionStatus, generateMaskedPII } from "helpers/utils";

const PassportDetails = props => {
  const { t } = useTranslation();
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [userDetails, setUserDetails] = useState({
    passportNumber: "",
    passportType: "",
    countryCode: "",
    fullName: "",
    gender: "Male",
    dob: "",
    address: "",
    placeOfBirth: "",
    placeOfIssue: "",
    issueDate: "",
    expireDate: "",
  });
  const [loading, setLoading] = useState(false);
  const [viewType, setViewType] = useState("view");
  const [errors, setErrors] = useState({});
  const candidateDetails = props?.data?.fields
    ? JSON.parse(props?.data?.fields)
    : "";

  const validatePassportNumber = val => {
    let inputvalues = val;
    let regex = new RegExp(/^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/);
    return regex.test(inputvalues);
  };

  const imageTypeAllowed = [
    "application/doc",
    "application/docx",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleFileUpload = async e => {
    setErrors({ ...errors, attachmentFile: "" });
    if (e?.target?.files?.length > 0) {
      let maxSize = 25;
      let isError = false;
      if (e?.target?.files?.length > 1) {
        toast.error(t(`Passport.Cannot Select More than one Attachment`));
        return false;
      }
      for (let i = 0; i < e?.target?.files?.length; i++) {
        if (!imageTypeAllowed?.includes(e?.target?.files[i]?.type)) {
          isError = true;
        }
        let megabytes = bytesToMB(e?.target?.files[i].size);
        if (megabytes > maxSize) {
          toast.error(
            t(`Passport.Please select attachment of size below 25 MB`)
          );
          return false;
        }
        setAttachmentFile(e?.target?.files[i]);
      }
      if (isError) {
        toast.error(
          t(`Passport.Please upload attachment with the following types`)
        );
        setLoading(false);
        return;
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    let error = {};
    let isError = false;
    if (isEmpty(userDetails?.passportNumber)) {
      error = { ...error, passportNumber: "This Field is Required" };
      isError = true;
    }
    if (isEmpty(userDetails?.passportType)) {
      error = { ...error, passportType: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (isEmpty(userDetails?.countryCode)) {
      error = { ...error, countryCode: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (!attachmentFile) {
      error = {
        ...error,
        attachmentFile: t(`Passport.Attachment is Required`),
      };
      isError = true;
    }
    if (isEmpty(userDetails?.fullName)) {
      error = { ...error, fullName: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (isEmpty(userDetails?.gender)) {
      error = { ...error, gender: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.dob) {
      error = { ...error, dob: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.placeOfBirth) {
      error = { ...error, placeOfBirth: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.placeOfIssue) {
      error = { ...error, placeOfIssue: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (isEmpty(userDetails?.address)) {
      error = { ...error, address: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.issueDate) {
      error = { ...error, issueDate: t(`Passport.This Field is Required`) };
      isError = true;
    }
    if (!userDetails?.expireDate) {
      error = { ...error, expireDate: t(`Passport.This Field is Required`) };
      isError = true;
    }

    if (!userDetails?.passportNumber?.trim()) {
      error = {
        ...error,
        passportNumber: t(`Passport.Please Enter Valid Details`),
      };
      isError = true;
    }

    if (isError) {
      toast.error(t(`Passport.Please Enter Valid Details`));
      setLoading(false);
      setErrors(error);
      return false;
    }

    let userID = props?.user_id;

    let payload = {
      ...userDetails,
      type: "passportDetails",
      new_status: "Passport Details",
      attachmentFile: attachmentFile,
      appl_id: props?.appl_id,
      device_info: "",
    };

    await uploadUserDocuments(payload, userID)
      .then(res => {
        toast.success(t(`Passport.Passport Details Updated Successfully`));
        props?.onSubmit();
        setViewType("view");
      })
      .then(err => {
        if (err?.response?.message) {
          toast.error(JSON.stringify(err?.response?.message));
        }
      });
  };

  const handleAttachmentOpen = () => {
    if (attachmentFile) {
      if (typeof attachmentFile === "string") {
        window.open(attachmentFile);
      } else {
        window.open(URL.createObjectURL(attachmentFile));
      }
    }
  };

  const handleReset = () => {
    if (props?.data) {
      let myData = JSON.parse(props?.data?.fields);
      let attachmentNew = props?.data?.files;
      setUserDetails({
        passportNumber: myData?.passportNumber,
        passportType: myData?.passportType,
        countryCode: myData?.countryCode,
        fullName: myData?.fullName,
        gender: myData?.gender,
        dob: myData?.dob,
        address: myData?.address,
        placeOfBirth: myData?.placeOfBirth,
        placeOfIssue: myData?.placeOfIssue,
        issueDate: myData?.issueDate,
        expireDate: myData?.expireDate,
      });
      setAttachmentFile(attachmentNew);
    }
  };

  useEffect(() => {
    if (props?.data) {
      let myData = JSON.parse(props?.data?.fields);
      let attachmentNew = props?.data?.files;
      setUserDetails({
        passportNumber: myData?.passportNumber,
        passportType: myData?.passportType,
        countryCode: myData?.countryCode,
        fullName: myData?.fullName,
        gender: myData?.gender,
        dob: myData?.dob,
        address: myData?.address,
        placeOfBirth: myData?.placeOfBirth,
        placeOfIssue: myData?.placeOfIssue,
        issueDate: myData?.issueDate,
        expireDate: myData?.expireDate,
      });
      setAttachmentFile(attachmentNew);
    }
  }, [props?.data]);

  return (
    <>
      {/* <div className="modal-header  d-flex justify-content-between align-items-center">
        <h4 className="m-0">
          {viewType === "edit" ? "Upload" : "View"} Passport Details
        </h4>
        <div className="filter-content cross" onClick={() => props?.close()}>
          <img src={cross} alt="" />
        </div>
      </div> */}
      <div className="d-flex justify-content-between align-items-center modal-subheading mb-2">
        <h4 className="d-flex gap-2 align-items-center">
          {t(`Passport.Passport Details`)}
        </h4>
        <div>
          {viewType === "view" ? (
            <Link
              className="text-success blue-icon blue-color4"
              to={`#`}
              onClick={() => setViewType("edit")}
              title={t(`Passport.Edit Details`)}
            >
              <img src={edit_icon} alt="delete_icon" />
            </Link>
          ) : (
            <button
              onClick={() => {
                setViewType("view");
                handleReset();
              }}
              className="btn btn-secondary"
            >
              {t(`Passport.Cancel`)}
            </button>
          )}
        </div>
      </div>
      {viewType === "edit" && (
        <div className="filters-cards-cross">
          <form
            onSubmit={handleSubmit}
            id="schedulef2f"
            style={{ display: "block" }}
          >
            <div className="form-group">
              <div className="row">
                <div className="voter-upload">
                  <label className="btn btn-primary upload-button">
                    <FontAwesomeIcon icon={faUpload} />
                    <span className="mx-2">
                      {t(`Passport.Upload Passport`)}
                    </span>
                    <input
                      type="file"
                      multiple
                      accept={imageTypeAllowed.join(",")}
                      onChange={e => {
                        handleFileUpload(e);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                  {attachmentFile && (
                    <FontAwesomeIcon
                      className="mx-4"
                      icon={faImages}
                      style={{ cursor: "pointer" }}
                      width={"25px"}
                      height={"25px"}
                      onClick={() => handleAttachmentOpen()}
                    />
                  )}

                  <p className="pb-2">
                    {t(`Passport.Supported file types are`)}
                  </p>
                  {errors?.attachmentFile && (
                    <p className="text-danger mt-2 mx-1">
                      {errors?.attachmentFile}
                    </p>
                  )}
                </div>
                <div className="row form-upload-card">
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Passport Number`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="voterId"
                        type="text"
                        className="form-control"
                        placeholder={t(`Passport.Passport Number`)}
                        value={userDetails?.passportNumber}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            passportNumber: e.target.value,
                          });
                          setErrors({ ...errors, passportNumber: "" });
                        }}
                        title={`${t(`Passport.Passport Number`)}`}
                      />
                    </div>
                    {errors?.passportNumber && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.passportNumber}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Passport Type`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="voterId"
                        type="text"
                        className="form-control"
                        placeholder={t(`Passport.Passport Type`)}
                        value={userDetails?.passportType}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            passportType: e.target.value,
                          });
                          setErrors({ ...errors, passportType: "" });
                        }}
                        title={`${t(`Passport.Passport Type`)}`}
                      />
                    </div>
                    {errors?.passportType && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.passportType}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Country Code`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="countryCode"
                        type="text"
                        className="form-control"
                        placeholder={t(`Passport.Enter Country Code`)}
                        value={userDetails?.countryCode}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            countryCode: e.target.value,
                          });
                          setErrors({ ...errors, countryCode: "" });
                        }}
                        title={`${t(`Passport.Country Code`)}`}
                      />
                    </div>
                    {errors?.countryCode && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.countryCode}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">{t(`Passport.Name`)}</span>
                    <div className="mt-2">
                      <input
                        for="name"
                        type="text"
                        className="form-control"
                        placeholder={t(`Passport.Enter Full Name`)}
                        value={userDetails?.fullName}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            fullName: e.target.value,
                          });
                          setErrors({ ...errors, fullName: "" });
                        }}
                        title={`${t(`Passport.Name`)}`}
                      />
                    </div>
                    {errors?.fullName && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.fullName}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">{t(`Passport.Gender`)}</span>
                    <div className="mt-2">
                      <select
                        for="gender"
                        className="form-control"
                        value={userDetails?.gender}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            gender: e.target.value,
                          });
                          setErrors({ ...errors, gender: "" });
                        }}
                        onMouseEnter={e => {
                          e.target.setAttribute(
                            "title",
                            e.target.options[e.target.selectedIndex].text
                          );
                        }}
                      >
                        <option value="Male">{t(`Passport.Male`)}</option>
                        <option value="Female">{t(`Passport.Female`)}</option>
                        <option value="Other">{t(`Passport.Other`)}</option>
                      </select>
                    </div>
                    {errors?.gender && (
                      <p className="text-danger mt-2 mx-1">{errors?.gender}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Date of Birth`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.dob ? new Date(userDetails?.dob) : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            dob: date,
                          });
                          setErrors({ ...errors, dob: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        scrollableYearDropdown
                        maxDate={new Date()?.setFullYear(
                          new Date()?.getFullYear() - 18
                        )}
                        placeholderText={t(`Passport.Select Date`)}
                        title={`${t(`Passport.Date of Birth`)}`}
                      />
                    </div>
                    {errors?.dob && (
                      <p className="text-danger mt-2 mx-1">{errors?.dob}</p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Place of Birth`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="spouseName"
                        type="text"
                        className="form-control"
                        placeholder={t(`Passport.Enter Place of Birth`)}
                        value={userDetails?.placeOfBirth}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            placeOfBirth: e.target.value,
                          });
                          setErrors({ ...errors, placeOfBirth: "" });
                        }}
                        title={`${t(`Passport.Place of Birth`)}`}
                      />
                    </div>
                    {errors?.placeOfBirth && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.placeOfBirth}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Place of Issue`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="spouseName"
                        type="text"
                        className="form-control"
                        placeholder={t(`Passport.Enter Place of Issue`)}
                        value={userDetails?.placeOfIssue}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            placeOfIssue: e.target.value,
                          });
                          setErrors({ ...errors, placeOfIssue: "" });
                        }}
                        title={`${t(`Passport.Place of Issue`)}`}
                      />
                    </div>
                    {errors?.placeOfIssue && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.placeOfIssue}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Issued Date`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.issueDate
                            ? new Date(userDetails?.issueDate)
                            : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            issueDate: date,
                          });
                          setErrors({ ...errors, issueDate: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        maxDate={new Date()}
                        placeholderText={t(`Passport.Select Date`)}
                        title={`${t(`Passport.Issued Date`)}`}
                      />
                    </div>
                    {errors?.issueDate && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.issueDate}
                      </p>
                    )}
                  </div>
                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Expiry Date`)}
                    </span>
                    <div className="mt-2">
                      <DatePicker
                        selected={
                          userDetails?.expireDate
                            ? new Date(userDetails?.expireDate)
                            : ""
                        }
                        showYearDropdown
                        name="dob"
                        onChange={date => {
                          setUserDetails({
                            ...userDetails,
                            expireDate: date,
                          });
                          setErrors({ ...errors, expireDate: "" });
                        }}
                        className="form-control"
                        dateFormat="dd-MM-yyyy"
                        minDate={new Date()}
                        placeholderText={t(`Passport.Select Date`)}
                        title={`${t(`Passport.Expiry Date`)}`}
                      />
                    </div>
                    {errors?.expireDate && (
                      <p className="text-danger mt-2 mx-1">
                        {errors?.expireDate}
                      </p>
                    )}
                  </div>

                  <div className="col-lg-4 col-md-6  mb-4">
                    <span className="font-size-14">
                      {t(`Passport.Address`)}
                    </span>
                    <div className="mt-2">
                      <input
                        for="address"
                        type="text"
                        className="form-control"
                        value={userDetails?.address}
                        placeholder={t(`Passport.Enter Address`)}
                        onChange={e => {
                          setUserDetails({
                            ...userDetails,
                            address: e.target.value,
                          });
                          setErrors({ ...errors, address: "" });
                        }}
                        title={`${t(`Passport.Address`)}`}
                      />
                    </div>
                    {errors?.address && (
                      <p className="text-danger mt-2 mx-1">{errors?.address}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="serach-btn d-flex justify-content-start">
                <button className="btn btn-primary search">
                  {t(`Passport.Save`)}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {viewType === "view" && candidateDetails && (
        <>
          <div className="personal-card">
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Passport Number`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {generateMaskedPII(candidateDetails?.passportNumber, 2)}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Passport Type`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.passportType}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Country Code`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.countryCode}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">{t(`Passport.Name`)}</label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.fullName}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">{t(`Passport.Gender`)}</label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.gender}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Date of Birth`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {new Date(candidateDetails?.dob)?.toDateString()}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Place of Birth`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.placeOfBirth}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Place of Issue`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.placeOfIssue}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Issued Date`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {new Date(candidateDetails?.issueDate)?.toDateString()}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Expiry Date`)}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">
                    {new Date(candidateDetails?.expireDate)?.toDateString()}
                  </span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">{t(`Passport.Address`)}</label>
                <p className="text-wrap text-truncate-2 ">
                  <span className="">{candidateDetails?.address}</span>
                </p>
              </div>
            </div>
            <div className="document-detail-badge">
              <div>
                <label className="data-label">
                  {t(`Passport.Document`)}
                  {attachmentFile &&
                  !checkPermissionStatus(
                    "personal-id-info",
                    "view_unmasked"
                  ) ? (
                    <>
                      {" "}
                      <FontAwesomeIcon
                        icon={faLock}
                        title="You are not authorized to view this document"
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </label>
                <p className="text-wrap text-truncate-2 ">
                  {attachmentFile && (
                    <FontAwesomeIcon
                      className="mx-4"
                      icon={faImages}
                      style={{ cursor: "pointer" }}
                      width={"25px"}
                      height={"25px"}
                      onClick={() =>
                        !checkPermissionStatus(
                          "personal-id-info",
                          "view_unmasked"
                        )
                          ? null
                          : handleAttachmentOpen()
                      }
                    />
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="line-braker"></div>
        </>
      )}
      {viewType === "view" && !candidateDetails && (
        <p className="pdf-details">{t(`Passport.No Details Available`)}</p>
      )}
    </>
  );
};

export default PassportDetails;
